import React from 'react';
import { getScreenName } from '../../../Utils/helper';
import { PopupInput } from '../HealthPlan/styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function EmailInputField(props) {
  const { element, inputFieldErrorHandler, index, fromPdp, inAppForm } = props;
  // console.log("props", props);
  element['error_text'] = `Please Enter ${element?.question_text}`;
  const handler = (event) => {
    inputFieldErrorHandler(event.target.value, index);
  };
  const fireInputEvent = (event) => {
    if (!inAppForm)
      fireEvent({
        category: 'entered_mobile',
        screen_name: getScreenName(),
        sku_type: fromPdp ? 'pdp' : 'clinic',
        page_url: typeof window != 'undefined' ? window.location.href : 'NA',
        parent: 'booking_confirmation_popup',
        support_variable: event?.target.value,
      });
  };
  return (
    <>
      <h2
        style={{
          fontSize: '18px',
          width: '90%',
          margin: '10px auto 0',
          color: 'rgba(0, 0, 0, 0.8)',
        }}
      >
        {element?.question_text}
      </h2>
      <PopupInput
        type="email"
        placeholder="Enter Email id* "
        autoFocus={index == 0 ? true : false}
        id="email"
        onChange={(event) => {
          handler(event);
        }}
        required={element?.required == 1 ? true : false}
        onBlur={(event) => {
          fireInputEvent(event);
        }}
      />
    </>
  );
}
